import storage from 'local-storage-fallback'

import isUndefined from 'lodash/isUndefined'
import compact from 'lodash/compact'
import map from 'lodash/map'
import split from 'lodash/split'
import union from 'lodash/union'
import toString from 'lodash/toString'
import toInteger from 'lodash/toInteger'

export default {
  methods: {
    getOriginalPushVisitedList() {
      const getStorageData = storage.getItem('push_visited')
      return !isUndefined(getStorageData) ? compact(map(split(getStorageData, ','), Number)) : [] // convert string to array of Integers with no falsey values
    },
    updatePushVisitedList(appendNid) {
      const originalList = this.getOriginalPushVisitedList()
      const newList = union(originalList, [toInteger(appendNid)]) // no duplicate TID
      storage.setItem('push_visited', toString(newList)) // toString in case cookies is used
    },
  },
}



// WEBPACK FOOTER //
// ./components/mixins/pushVisitedList.js